/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_FAILURE,
  UPDATE_USER_DETAIL_SUCCESS,
  UPDATE_USER_DETAIL_FAILURE,
  UPDATE_USER_PASSWORD_SUCCESS,
  UPDATE_USER_PASSWORD_FAILURE,
  SAVE_INVESTOR_PROFILE_SUCCESS,
  SAVE_INVESTOR_PROFILE_FAILURE,
} from "../actions/auth/authActionTypes";

const initialState = {
  userInfo: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USER_DETAIL_SUCCESS:
      return {
        getUserDetailSuccess: true,
        userInfo: action.payload.data,
      };
    case GET_USER_DETAIL_FAILURE:
      return {
        getUserDetailSuccess: false,
        userInfo: state.userInfo,
      };
    case UPDATE_USER_DETAIL_SUCCESS:
      return {
        userInfo: action.payload.data,
        updateUserDetailSuccess: true,
      };
    case UPDATE_USER_DETAIL_FAILURE:
      return {
        userInfo: state.userInfo,
        updateUserDetailSuccess: false,
        error: action.err.message,
      };

    case UPDATE_USER_PASSWORD_SUCCESS:
      return {
        userInfo: action.payload.data,
        updatePasswordSuccess: true,
      };
    case UPDATE_USER_PASSWORD_FAILURE:
      return {
        userInfo: state.userInfo,
        updatePasswordSuccess: false,
        error: action.payload.message,
      };
    case SAVE_INVESTOR_PROFILE_SUCCESS:
      return {
        userInfo: state.userInfo,
        saveInvestorProfileSuccess: true,
        investorProfile: action.payload.user.investmentProfile,
      };
    case SAVE_INVESTOR_PROFILE_FAILURE:
      return {
        userInfo: state.userInfo,
        saveInvestorProfileSuccess: false,
        investorProfile: null,
      };

    default:
      return state;
  }
}
